const uz = {
  loadingTypes: {
    notSpecified: "ko'rsatilmagan",
  },
};

export { uz };
